import { render, staticRenderFns } from "./BulkMessagingList.vue?vue&type=template&id=0159656a&scoped=true&"
import script from "./BulkMessagingList.vue?vue&type=script&lang=js&"
export * from "./BulkMessagingList.vue?vue&type=script&lang=js&"
import style0 from "./BulkMessagingList.vue?vue&type=style&index=0&id=0159656a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0159656a",
  null
  
)

export default component.exports